module.exports = __webpack_public_path__ + "static/media/4.be7ef7bb.jpg";